export default {
  //auth
  SET_AUTHENTICATED(state, value) {
    state.auth.authenticated = value;
  },

  SET_USER_OBJECT(state, value) {
    state.auth.userObject = value;
  },

  SET_AUTH_TOKEN(state, value) {
    state.auth.accessToken = value;
  },

  SET_AUTH_REFRESH_TOKEN(state, value) {
    state.auth.refreshToken = value;
  },

  SET_KEYCLOAK(state, payload) {
    state.keycloak = payload;
  },

  SET_LOGIN_URL(state, value) {
    state.auth.loginUrl = value;
  },

  SET_LOGOUT_URL(state, value) {
    state.auth.logoutUrl = value;
  },

  //form------------------------------------------------------------------------
  SET_CASES(state, payload) {
    state.intakeFormData.patientCases = payload;
  },

  SET_PATIENT_CASE(state, payload) {
    state.intakeFormData.patientCase = payload;
    state.intakeFormData.formData['patientCaseId'] = payload.patientCaseId;
  },

  SET_DOCTOR_OPTIONS(state, payload) {
    let doctors = payload.map(doctor => {
      return {
        text: doctor.name,
        value: doctor.id
      };
    });
    state.intakeFormData.doctorOptions = doctors;
  },

  SET_CODE_INFO(state, value) {
    state.intakeFormData.code = value;
  },

  SET_CODE(state, value) {
    state.intakeFormData.codeId = value;
  },

  SET_ADDRESS_LIST(state, payload) {
    let addresses = payload.map(address => {
      return {
        text: address.streetName,
        value: address.streetName
      };
    });
    state.createUserPage.addresses = addresses;
  },

  SET_RECAPTCHA(state, value) {
    state.intakeFormData.formData['recaptcha'] = value;
  },

  //calendar page------------------------------------------------------------------------
  SET_TIME_SLOT_DIALOG(state, action) {
    state.appointmentsCalendarPage.showTimeSlotDialog = action;
  },

  SET_CURRENT_CALENDAR_EVENT_RANGE(state, payload) {
    state.appointmentsCalendarPage.currentCalendarRange = payload;
  },

  SET_CURRENT_CALENDAR_EVENTS(state, payload) {
    state.appointmentsCalendarPage.calendarEvents = payload;
  },

  SET_CURRENT_CALENDAR_LOADER(state, action) {
    state.appointmentsCalendarPage.calendarLoader = action;
  },

  SET_CLICKED_DATE(state, payload) {
    state.appointmentsCalendarPage.clickedDate = payload;
  },

  SET_LOCATIONS(state, payload) {
    state.appointmentsCalendarPage.locations = payload;
  },

  SET_LOCATION(state, payload) {
    state.appointmentsCalendarPage.location = payload;
  },

  // selected day ------------------------------------------------------------------------
  SET_SELECTED_DATE_TIME_APPOINTMENT(state, payload) {
    state.appointmentsSelectedDayPage.selectedAppoinmentDateTime = payload;
  },

  SET_APPOINTMENT_BOOKING_DIALOG(state, action) {
    state.appointmentsSelectedDayPage.showAppointmentBookingDialog = action;
  },

  SET_APPOINTMENTS(state, payload) {
    state.appointmentsSelectedDayPage.appointments = payload;
  },

  SET_APPOINTMENTS_LOADER(state, action) {
    state.appointmentsSelectedDayPage.loadingAppointments = action;
  },

  SET_SELECTED_DATE(state, payload) {
    state.appointmentsSelectedDayPage.selectedDate = payload;
  },

  SET_TIME_SLOTS(state, payload) {
    let payloadWithLoader = payload.map(item => {
      return {
        ...item,
        loader: false
      };
    });
    state.appointmentsSelectedDayPage.timeSlots = payloadWithLoader;
  },

  SET_TIME_SLOTS_LOADER(state, action) {
    state.appointmentsSelectedDayPage.loadingSlots = action;
  },

  SET_SELECTED_SLOT(state, payload) {
    state.appointmentsSelectedDayPage.selectedSlot = payload;
  },

  SET_SINLGE_SLOT_LOADER(state, payload) {
    state.appointmentsSelectedDayPage.timeSlots.forEach(slot => {
      if (slot.id == payload.id) slot.loader = payload.action;
    });
  },

  //generic
  SET_SNACKBAR(state, payload) {
    state.config.snackbar = payload;
  },

  SET_SHOW_LOADER(state, payload) {
    state.config.loader.show = payload.action;
    state.config.loader.text = payload.text;
  },

  //intake form
  SET_INTAKE_FORM_DATA_ITEM(state, payload) {
    state.intakeFormData.formData[payload.key] = payload.value;
  },

  SET_CURRENT_STEP_INTAKE_FORM(state, step) {
    state.intakeFormData.currentStep = step;
  },

  RESET_INTAKE_FORM_DATA(state) {
    state.intakeFormData.formData = JSON.parse(JSON.stringify(state.intakeFormData.formDataPrestine));
  },

  SET_HOUSEMATE_CNT(state, value) {
    state.intakeFormData.housemateCnt = value;
  },

  FORM_SUBMITTED(state, value) {
    state.intakeFormData.formSubmitted = value;
  },

  //generic
  SET_SELECTED_LANGUAGE(state, value) {
    state.config.selectedLanguage = value;
  }
};
